<template>
    <UApp :locale="uiLocale">
        <!-- Each layout renders its own <router-view />; the layout component is the page's
             frame, not a wrapper around it (vue-spec templates/shell/). -->
        <component :is="layout" />
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import * as locales from '@nuxt/ui/locale'

    import Default from '@/layouts/Default.vue'
    import Blank   from '@/layouts/Blank.vue'

    const route = useRoute()
    const { locale } = useI18n()

    // Keep Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
